module.exports = __webpack_public_path__ + "static/media/unsubscribe.7f1c3e18.webp";